






























































































import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
import MovieRate from '@/enums/movieRate';
import Movie from '@/objects/movie';
import ServiceAgent from '@/services/serviceAgent';

const serviceAgent = new ServiceAgent();

@Component
export default class MovieListItemButtons extends Vue {
    @Prop() movie!: Movie;

    @Prop() expanded = false;

    opened = false;

    MovieRate = MovieRate;

    removeDialog = false;

    async rateMovie(movieRate: MovieRate) {
        this.removeDialog = false;

        this.movie.MovieRate = movieRate;

        await serviceAgent.RateMovie(this.movie.Id, this.userId, movieRate)
            .then(() => this.$store.dispatch('setUserMovies'));
    }

    get userId() {
        const result = this.$store.getters.userId;

        return result;
    }
}
